// extracted by mini-css-extract-plugin
export default {"selection":"ManageSelection_selection__t+FaaGME","countSelected":"ManageSelection_countSelected__+RanH1DO"};